import React, { createContext, useContext, useMemo, useReducer } from 'react';

const emptyModelDetailsBooksContextValue = {
    contactID: null,
    modelPlaylists: [],
    websiteData: [],
    scope: null,
    actions: {
        onAdd: () => {},
        onEdit: () => {},
        onSelect: () => {},
        onDelete: () => {},
        onOpenPublishDrawer: () => {},
        onOpenAddBookDrawer: () => {},
        onOpenBookCoverDrawer: () => {},
        onOpenBookInfoDrawer: () => {},
        onOpenBookPreviewDrawer: () => {},
        onOpenBooksDrawer: () => {},
        onSetFastPackage: () => {},
        onSetCompCard: () => {},
        onSetFavourite: () => {},
        onRemoveCover: () => {},
    },
    packageSection: {
        active: false,
        group: null,
        name: null,
        onAdd: () => {},
        onRemove: () => {},
        playlists: [],
    },
    readOnly: false,
    refreshing: false,
    spinning: false,
};

export const ModelDetailsBooksContext = createContext(emptyModelDetailsBooksContextValue);

export const ModelDetailsBooksContextProvider = ({
    addedPlaylists,
    contactID,
    modelPlaylists,
    packageGroup,
    packageName,
    scope,
    onAddBookToPackage,
    onRemoveBookFromPackage,
    onAddNewBook,
    onEditBook,
    onSelectBook,
    readOnly,
    refreshing,
    spinning,
    onOpenPublishDrawer,
    onOpenAddBookDrawer,
    onOpenBookCoverDrawer,
    onOpenBookInfoDrawer,
    onOpenBookPreviewDrawer,
    onOpenBooksDrawer,
    onCloneBook,
    onSetFastPackage,
    onSetCompCard,
    onSetFavourite,
    onRemoveCover,
    onDeleteBook,
    websiteData,
    children,
}) => {
    const isPackage = scope === 'package';

    const data = useMemo(
        () => ({
            ...emptyModelDetailsBooksContextValue,
            contactID,
            scope: scope ? scope : 'model-details',
            modelPlaylists,
            websiteData,
            actions: {
                onAdd: onAddNewBook,
                onEdit: onEditBook,
                onDelete: onDeleteBook,
                onSelect: onSelectBook,
                onCloneBook,
                onOpenPublishDrawer,
                onOpenAddBookDrawer,
                onOpenBookCoverDrawer,
                onOpenBookInfoDrawer,
                onOpenBookPreviewDrawer,
                onOpenBooksDrawer,
                onRemoveCover,
                onSetFastPackage,
                onSetCompCard,
                onSetFavourite,
            },
            packageSection: {
                active: isPackage ? true : false,
                // Nome del package e del gruppo di destinazione: servono a dire, sulla riga,
                // dove il book sta per finire. Se mancano si ricade su un testo generico.
                group: packageGroup,
                name: packageName,
                onAdd: isPackage ? onAddBookToPackage : () => {},
                onRemove: isPackage ? onRemoveBookFromPackage : () => {},
                playlists: addedPlaylists,
            },
            readOnly,
            refreshing,
            spinning,
        }),
        [
            addedPlaylists,
            contactID,
            scope,
            isPackage,
            modelPlaylists,
            packageGroup,
            packageName,
            websiteData,
            onAddBookToPackage,
            onRemoveBookFromPackage,
            onAddNewBook,
            onSelectBook,
            readOnly,
            refreshing,
            spinning,
            onOpenPublishDrawer,
            onOpenAddBookDrawer,
            onOpenBookCoverDrawer,
            onOpenBookInfoDrawer,
            onOpenBookPreviewDrawer,
            onOpenBooksDrawer,
            onSetFastPackage,
            onSetCompCard,
            onSetFavourite,
            onRemoveCover,
            onDeleteBook,
        ]
    );

    return <ModelDetailsBooksContext.Provider value={data}>{children}</ModelDetailsBooksContext.Provider>;
};

export function useModelDetailsBooks() {
    return useContext(ModelDetailsBooksContext);
}
